import { useEffect, useState } from "react";
import { api } from "../../../shared/api/client";
import { Empty, Loading } from "../../../shared/components/Empty";
import { Pill } from "../../../shared/components/Pill";
import { toast } from "../../../shared/stores/toasts";

type Backup = { id: number; backup_type: string; status: string; started_at: string; completed_at: string | null; size_bytes: number | null };

export function AdminBackup() {
  const [items, setItems] = useState<Backup[] | null>(null);
  const reload = () => api.get<Backup[]>("/admin/backups").then((r) => setItems(r.data));
  useEffect(() => { reload(); }, []);
  const trigger = async () => {
    try { await api.post("/admin/backups/run"); toast.success("백업 시작"); reload(); }
    catch (e: any) { toast.error("실패", e?.response?.data?.error?.message); }
  };
  return (
    <div className="t-grid cols-1">
      <div className="t-card" style={{ flexDirection: "row", alignItems: "center", gap: 12 }}>
        <div>
          <div style={{ fontWeight: 700 }}>수동 백업</div>
          <div style={{ fontSize: 12, color: "var(--text-3)", marginTop: 4 }}>전체 테이블의 논리 덤프를 생성하고 객체 스토리지에 저장합니다.</div>
        </div>
        <button className="t-btn t-btn-primary" style={{ marginLeft: "auto" }} onClick={trigger}>지금 백업</button>
      </div>
      {items === null && <Loading/>}
      {items?.length === 0 && <Empty msg="백업 이력이 없습니다"/>}
      <div className="t-card" style={{ padding: 0 }}>
        <div className="t-list" style={{ padding: 16 }}>
          {items?.map((b) => (
            <div key={b.id} className="t-row">
              <Pill kind="info">{b.backup_type}</Pill>
              <span className="meta" style={{ flex: 1 }}>{new Date(b.started_at).toLocaleString("ko-KR")}</span>
              <span className="num">{b.size_bytes ? (b.size_bytes / 1024).toFixed(1) + " KB" : "—"}</span>
              <Pill kind={b.status === "SUCCESS" ? "ok" : b.status === "FAILED" ? "danger" : "warn"}>{b.status}</Pill>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
